export default __webpack_public_path__ + "static/self-help-icon-c3e3e4fe3dce760167aa033c2fa12913.svg";